module.exports = __webpack_public_path__ + "media/司歌.9fd87838.mp3";